import Actions from './action';
export const initState = {
	affiliateByIDLoading: true,
	affiliateByIDData: [],
	affiliateByIDCommissionProfileLoading: true,
	affiliateByIDCommissionProfileData: [],
	deleteAffiliateByIDCommissionProfileLoading: false,
};

const affiliateByIDReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.GET_AFFILIATE_BY_ID_STARTED: {
			return {
				...state,
				affiliateByIDLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_STARTED_SUCCESS: {
			return {
				...state,
				affiliateByIDLoading: false,
				affiliateByIDData: action.response,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_STARTED_FAIL: {
			return {
				...state,
				affiliateByIDLoading: false,
				affiliateByIDData: [],
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED: {
			return {
				...state,
				affiliateByIDCommissionProfileLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS: {
			return {
				...state,
				affiliateByIDCommissionProfileLoading: false,
				affiliateByIDCommissionProfileData: action.response,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL: {
			return {
				...state,
				affiliateByIDCommissionProfileLoading: false,
				affiliateByIDCommissionProfileData: [],
			};
		}
		case Actions.types.DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED: {
			return {
				...state,
				deleteAffiliateByIDCommissionProfileLoading: true,
			};
		}
		case Actions.types.DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS: {
			return {
				...state,
				deleteAffiliateByIDCommissionProfileLoading: false,
			};
		}
		case Actions.types.DELETE_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL: {
			return {
				...state,
				deleteAffiliateByIDCommissionProfileLoading: false,
			};
		}
		default:
			return state;
	}
};

export default affiliateByIDReducer;
